import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Verificar si el usuario está autenticado
 */
const isAuthenticated = () => {
  const authToken = localStorage.getItem('authToken');
  return !!authToken;
};

/**
 * Componente de ruta privada mejorado
 * Protege rutas que requieren autenticación
 */
const PrivateRoute = ({ element }) => {
  if (!isAuthenticated()) {
    // Limpiar cualquier dato residual
    localStorage.removeItem('authToken');
    localStorage.removeItem('userData');
    localStorage.removeItem('displayName');
    
    // Redirigir al login
    return <Navigate to="/" replace />;
  }
  
  return element;
};

export default PrivateRoute;
